import API from "@/utils/Api";
import { get } from "@/context/context";
import {AxiosResponse} from "axios";
import {EventRepository} from "@/repositories/EventRepository";
import {ListRequest} from "@/models/Event/ListRequest";
import {RequestConfig} from "@/models/RequestConfig";
import {EventResponse} from "@/models/Event/EventResponse";
import {EventRequest} from "@/models/Event/EventRequest";

export class EventApi implements EventRepository {

    private api: API = get('api');

    public async getEvents(payload: ListRequest, config?: RequestConfig):Promise<EventResponse>{
        const response: AxiosResponse<EventResponse> =
            await this.api.post('/uploader/wix/availableevents', payload, config);
        const { data } = response;
        return data;
    }

    public async createEvent(payload: EventRequest, config?: RequestConfig):Promise<any>{
        const response: AxiosResponse<any> =
            await this.api.post('/create-event-new', payload, config);
        const { data } = response;
        return data;
    }
}
